import { Injectable } from '@angular/core';
import { CustomCategoryHierarchy } from '@catalog/const';
import { select, Store } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { StateWithCatalog } from '../store/catalog-state';
import { CatalogSelectors } from '../store/selectors';

// Отвечает за детальную инфу о категории в текущей версии каталога
@Injectable({
  providedIn: 'root',
})
export class CategoryDetailsFacade {
  constructor(private store: Store<StateWithCatalog>) {}

  getCategoryDetailsState(): Observable<StateUtils.LoaderState<CustomCategoryHierarchy>> {
    return this.store.pipe(select(CatalogSelectors.getCategoryDetailsState));
  }

  getCategoryDetails(): Observable<CustomCategoryHierarchy> {
    return this.store.pipe(select(CatalogSelectors.getCategoryDetailsValue));
  }
}
